export default __webpack_public_path__ + "static/media/sandal12.e2760ac7.jpeg";